import React, { useEffect, useRef } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledCertSection = styled.section`
  max-width: 600px;
`;

const StyledCert = styled.div`
  margin-bottom: 20px;

  a {
    ${({ theme }) => theme.mixins.inlineLink};
  }

  .meta {
    font-family: var(--font-mono);
    font-size: var(--fz-xs);
    color: var(--light-slate);
  }
`;

const Certifications = () => {
  const data = useStaticQuery(graphql`
    query {
      certifications: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/content/certifications/" } }
        sort: { fields: [frontmatter___date], order: DESC }
      ) {
        edges {
          node {
            frontmatter {
              title
              issuer
              date(formatString: "MMM YYYY")
              link
            }
            html
          }
        }
      }
    }
  `);

  const prefersReducedMotion = usePrefersReducedMotion();
  const revealContainer = useRef(null);

  useEffect(() => {
    if (!prefersReducedMotion) {
      sr.reveal(revealContainer.current, srConfig());
    }
  }, []);

  return (
    <StyledCertSection id="certifications" ref={revealContainer}>
      <h2 className="numbered-heading">Certifications</h2>
      {data.certifications.edges.map(({ node }, i) => {
        const { title, issuer, date, link } = node.frontmatter;
        return (
          <StyledCert key={i}>
            <h3>
              {title}
              {link && (
                <>
                  {' '}
                  — <a href={link}>Credential</a>
                </>
              )}
            </h3>
            <div className="meta">{issuer} — {date}</div>
          </StyledCert>
        );
      })}
    </StyledCertSection>
  );
};

export default Certifications;
